import { FormIdUtil } from '@onshape/www-inertia';

const isFormFortAdded = ref(false);

export const useFormFiles = ({
  hekateStaticAsset,
  translationsStaticAsset,
  refreshOldTabsStaticAsset,
}: {
  hekateStaticAsset: StaticAssetInfo | null;
  translationsStaticAsset: StaticAssetInfo | null;
  refreshOldTabsStaticAsset: StaticAssetInfo | null;
}) => {
  if (!hekateStaticAsset) {
    throw new Error('Hekate static asset is required');
  }
  if (!translationsStaticAsset) {
    throw new Error('Translations static asset is required');
  }
  if (!refreshOldTabsStaticAsset) {
    throw new Error('Refresh old tabs static asset is required');
  }

  const addFormDefinitionToPage = ({ formId }: { formId: string }) => {
    useHead({
      link: [
        {
          rel: 'preload',
          href: hekateStaticAsset.cdnPathname,
          as: 'script',
          tagPriority: 5,
          'data-currentPathname': hekateStaticAsset.currentPathname,
        },
      ],
    });

    useHead({
      script: [
        {
          src: translationsStaticAsset.cdnPathname,
          async: false, // this must be loaded before the formfort.js
          tagPriority: 2,
          'data-currentPathname': translationsStaticAsset.currentPathname,
        },
      ],
    });

    useHead({
      script: [
        {
          src: `/api/fb/getFormDefinitionScript?formId=${formId}`,
          async: false, // this must be loaded before the formfort.js
          tagPriority: 2,
        },
      ],
    });

    if (formId === FormIdUtil.names.unifiedSignup) {
      addFormDefinitionToPage({ formId: FormIdUtil.names.signupSurvey });
    }
  };

  /** Add form definitions, translations and formfort.js to the page if needed */
  const loadHekate = async ({ formId }: { formId: string }) => {
    const hasUssForm = useState('has-uss-form');
    hasUssForm.value = hasUssForm.value || FormIdUtil.isCadInviteForm({ formId });

    addFormDefinitionToPage({ formId });

    if (isFormFortAdded.value) return;

    useHead({
      script: [
        {
          src: hekateStaticAsset.cdnPathname,
          type: 'text/javascript',
          async: true,
          tagPriority: 3,
          'data-currentPathname': hekateStaticAsset.currentPathname,
        },
        {
          src: refreshOldTabsStaticAsset.cdnPathname,
          type: 'text/javascript',
          async: true,
          tagPriority: 4,
          'data-currentPathname': refreshOldTabsStaticAsset.currentPathname,
        },
      ],
    });
    isFormFortAdded.value = true;
  };

  return {
    loadHekate,
    addFormDefinitionToPage,
  };
};
